import ReactGA from "react-ga"
 
export const GAinit = () => {
  ReactGA.initialize("UA-151608223-1")
}
 
export const GAlogPageView = () => {
  ReactGA.set({ page: window.location.pathname })
  ReactGA.pageview(window.location.pathname)
}

export const GAlogEvent = (category, action) => {
    ReactGA.event({
        category,
        action
    });
}


// WEBPACK FOOTER //
// ./src/components/common/GoogleAnalytics.js